import axios from 'axios'
import router from '../router'
import Swal from 'sweetalert2'

import store from '../store';


axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = '/api';

axios.interceptors.request.use(request => {
    // Credentials are injected server-side by the proxy (vue.config.js devServer
    // or public/api/proxy.php in production) — never sent from the browser.
    request.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    return request;
});

axios.interceptors.response.use(
    response => response,
    error => {
        const {
            status,
            data
        } = error.response


        if (status === 401) {
            Swal.fire({
                title: '',
                text: 'Sesi Login Anda telah berakhir, harap login kembali.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Go back!'
            }).then(async () => {
                store.dispatch("auth/logout");
                router.push({
                    name: 'landing'
                })
            })
        }

        if (status === 403) {
            Swal.fire({
                title: 'warning',
                text: 'Anda tidak memiliki hak untuk mengakses halaman ini!',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Go back!'
            }).then(async () => {
                router.push({
                    name: 'landing'
                })
            })
        }


        if (status === 409) {
            Swal.fire({
                icon: 'warning',
                title: '',
                text: typeof data === 'string' ? data : data.message
            })
        }

        if (status === 400) {
            Swal.fire({
                icon: 'error',
                title: '',
                text: typeof data === 'string' ? data : data.message
            })
        }

        if (status === 406) {
            Swal.fire({
                icon: 'error',
                title: '',
                text: 'Username / Password yang Anda masukan salah.'
            })
        }

        if (status === 422) {
            var errorMsg = '';
            Object.keys(data).forEach(function (name) {

                errorMsg += ' ' + data[name][0]
            });
            Swal.fire({
                icon: 'warning',
                text: errorMsg,
            });
            return Promise.resolve(errorMsg)
        }

        if (status >= 500) {
            if (data instanceof Blob) {
                var myReader = new FileReader();
                //handler executed once reading(blob content referenced to a variable) from blob is finished. 
                myReader.addEventListener("loadend", function (e) {
                    let dataMsg = JSON.parse(e.srcElement.result); //prints a string

                    Swal.fire({
                        icon: 'error',
                        title: '',
                        text: dataMsg.message
                    })
                });
                //start the reading process.
                myReader.readAsText(data);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: '',
                    text: data.message
                })
            }
        }

        return Promise.reject(error)
    }
)

export default axios;
